import React from 'react';
import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import LegalPage from './pages/LegalPage';
import Payment from './pages/Payment';
import Profile from './pages/Profile';
import DeleteAccount from './pages/DeleteAccount';
import './styles/globals.css';
import { apiPingTraffic } from './services/api'

function AppRoutes() {
  const { user, loading } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('admin') === '1') {
      document.cookie = 'ca_admin=1; max-age=31536000; path=/';
    }
    const isAdmin = document.cookie.includes('ca_admin=1');
    if (!isAdmin) {
      apiPingTraffic();
    }
  }, []);

  // Reveal #root once AuthContext has actually resolved who's logged in —
  // pairs with the inline script/style in index.html that hides it by
  // default whenever a stored session exists, to prevent the prerendered
  // landing page flashing before Dashboard on refresh.
  useEffect(() => {
    if (!loading) {
      document.documentElement.classList.remove('ca-has-session');
    }
  }, [loading]);

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#F7F7F5',
      }}>
        <div style={{
          width: 22,
          height: 22,
          border: '2px solid #E4E4DF',
          borderTopColor: '#1A1A1A',
          borderRadius: '50%',
          animation: 'spin 0.7s linear infinite',
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <Routes>
      {/* Root route: Shows Dashboard if logged in, otherwise LandingPage */}
      <Route path="/" element={user ? <Dashboard /> : <LandingPage />} />

      {/* Standalone Legal Page */}
      <Route path="/legal" element={<LegalPage />} />

      {/* Everything below requires login */}
      <Route path="/payment" element={user ? <Payment /> : <Navigate to="/" replace />} />
      <Route path="/profile" element={user ? <Profile /> : <Navigate to="/" replace />} />
      <Route path="/profile/delete" element={user ? <DeleteAccount /> : <Navigate to="/" replace />} />

      {/* Catch-all: Redirects any unknown URLs back to the root */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}